import { space } from '@synoptic/ui-kit/tokens.ts';
import { globalStyle, style } from '@vanilla-extract/css';
import { streamDescription } from '@/routes/_app.p.streams_.$id/stream-banner/stream-banner.css.ts';

export const customTargetsContainer = style([
  streamDescription,
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s8,
    marginBottom: space.s16,
  },
]);

export const customTargetItem = style([
  {
    display: 'flex',
    alignItems: 'center',
    gap: space.s8,
  },
]);

globalStyle(`${customTargetItem} svg`, {
  width: 20,
  height: 20,
});
